"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Link = _interopRequireDefault(require("../../Link"));

var SecondaryLink = (0, _styled.default)(_Link.default)(function (_ref) {
  var _ref2;

  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      mediaQueries = _ref$theme.mediaQueries,
      icon = _ref.icon,
      isMegaMenu = _ref.isMegaMenu;
  return _ref2 = {
    marginLeft: space.base,
    display: 'inline-block',
    fontSize: '1.2rem',
    lineHeight: '1.3rem'
  }, _defineProperty(_ref2, mediaQueries.small, {
    marginLeft: space.large,
    fontSize: '1.6rem',
    lineHeight: '1.7rem'
  }), _defineProperty(_ref2, mediaQueries.untilMedium, {
    display: isMegaMenu ? 'none' : 'inline-block'
  }), _defineProperty(_ref2, '&:hover span', {
    borderBottomColor: icon ? 'transparent !important' : 'inherit'
  }), _ref2;
});
var _default = SecondaryLink;
exports.default = _default;